// A tester keeps both bots in one chat list and both tabs in one browser, and
// telling them apart must not require reading a name.
//
// The value is read at build time on purpose, so the stand and production are
// different bundles by construction: the same `dist` cannot be served as both.
// A mark that could travel with the files would eventually mark the wrong one.
export function markDevBuild(): void {
  if (import.meta.env.VITE_APP_ENV !== 'dev') return;

  const icon = document.querySelector<HTMLLinkElement>('link[rel=icon]');
  if (icon) icon.href = '/favicon-dev.svg';

  document.title += ' · тест';
}
